"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = exports.ReactSEOMetaTags = void 0;
var ReactSEOMetaTags_1 = require("./ReactSEOMetaTags");
Object.defineProperty(exports, "ReactSEOMetaTags", { enumerable: true, get: function () { return ReactSEOMetaTags_1.ReactSEOMetaTags; } });
var ReactSEOMetaTags_2 = require("./ReactSEOMetaTags");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return ReactSEOMetaTags_2.ReactSEOMetaTags; } });
